import { EventEmitter, InjectionToken } from '@angular/core';


export const IErrorHandlerToken = new InjectionToken<string>("IErrorHandlerToken");

export interface IErrorHandler {

    DefaultError();

    Handle(error: string);

    Notify(msg : string);

    errorHandleRequest: EventEmitter<string>;
    notifyHandleRequest: EventEmitter<string>;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/contracts/IErrorHandler.ts